import { VariabilityStatus } from 'components/FinancialCheckup/MetricCard/MetricCard';

import { IVI_STEADY_THRESHOLD, IVI_VARIES_THRESHOLD, EVI_STEADY_THRESHOLD, EVI_VARIES_THRESHOLD } from './constants';

export const getIncomeVariabilityStatus = (ivi: number): VariabilityStatus => {
  if (ivi < IVI_STEADY_THRESHOLD) return VariabilityStatus.Steady;
  if (ivi < IVI_VARIES_THRESHOLD) return VariabilityStatus.Varies;
  return VariabilityStatus.VariesALot;
};

export const getExpenseVariabilityStatus = (evi: number): VariabilityStatus => {
  if (evi < EVI_STEADY_THRESHOLD) return VariabilityStatus.Steady;
  if (evi < EVI_VARIES_THRESHOLD) return VariabilityStatus.Varies;
  return VariabilityStatus.VariesALot;
};
